import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CentreComponent } from 'src/app/view/research/centre/centre.component';
import { FdpComponent } from 'src/app/view/research/fdp/fdp.component';
import { GuestComponent } from 'src/app/view/research/guest/guest.component';
import { MajorProjectComponent } from 'src/app/view/research/major-project/major-project.component';
import { MinorProjectComponent } from 'src/app/view/research/minor-project/minor-project.component';
import { PublicationComponent } from 'src/app/view/research/publication/publication.component';
import { ResearchComponent } from 'src/app/view/research/research.component';
import { SeminarComponent } from 'src/app/view/research/seminar/seminar.component';
import { StudentProjectComponent } from 'src/app/view/research/student-project/student-project.component';
import { WorkshopComponent } from 'src/app/view/research/workshop/workshop.component';
import { ResearchRoutingModule } from './research-routing.module';
import { NotFoundModule } from '../not-found/not-found/not-found.module';
import { ScholarshipComponent } from 'src/app/view/research/scholarship/scholarship.component';
import { CollaborativeComponent } from 'src/app/view/research/collaborative/collaborative.component';
import { ResultComponent } from 'src/app/view/research/result/result.component';
import { PoCoComponent } from 'src/app/view/research/po-co/po-co.component';
import { WTwooneTwotwoComponent } from 'src/app/view/research/workshop/w-twoone-twotwo/w-twoone-twotwo.component';
import { WTwotwoTwothreeComponent } from 'src/app/view/research/workshop/w-twotwo-twothree/w-twotwo-twothree.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LoaderModule } from '../loader/loader.module';
import { SharedModule } from '../shared/shared.module';
import { SpTwooneTwotwoComponent } from 'src/app/view/research/student-project/sp-twoone-twotwo/sp-twoone-twotwo.component';
import { SpTwotwoTwothreeComponent } from 'src/app/view/research/student-project/sp-twotwo-twothree/sp-twotwo-twothree.component';
import { MouComponent } from 'src/app/view/research/mou/mou.component';
import { ScTwooneTwotwoComponent } from 'src/app/view/research/scholarship/sc-twoone-twotwo/sc-twoone-twotwo.component';
import { ScTwotwoTwothreeComponent } from 'src/app/view/research/scholarship/sc-twotwo-twothree/sc-twotwo-twothree.component';
import { WTwothreeTwofourComponent } from 'src/app/view/research/workshop/w-twothree-twofour/w-twothree-twofour.component';
import { SpTwothreeTwofourComponent } from 'src/app/view/research/student-project/sp-twothree-twofour/sp-twothree-twofour.component';
import { ScTwothreeTwofourComponent } from 'src/app/view/research/scholarship/sc-twothree-twofour/sc-twothree-twofour.component';
import { FcTwothreeTwofourComponent } from 'src/app/view/research/mou/fc-twothree-twofour/fc-twothree-twofour.component';
import { FcTwotwoTwothreeComponent } from 'src/app/view/research/mou/fc-twotwo-twothree/fc-twotwo-twothree.component';
import { OnenineTwozeroComponent } from 'src/app/view/research/fdp/onenine-twozero/onenine-twozero.component';
import { TwothreeTwofourComponent } from 'src/app/view/research/fdp/twothree-twofour/twothree-twofour.component';
import { FcTwofourTwofiveComponent } from 'src/app/view/research/mou/fc-twofour-twofive/fc-twofour-twofive.component';
import { FcTwofiveTwosixComponent } from 'src/app/view/research/mou/fc-twofive-twosix/fc-twofive-twosix.component';
import { ResearchDevelopmentCellComponent } from 'src/app/view/research/research-development-cell/research-development-cell.component';
import { ResearchEntrepreneurshipCellComponent } from 'src/app/view/research/entrepreneurship-cell/research-entrepreneurship-cell.component';



@NgModule({
  declarations: [
    ResearchComponent,
    CentreComponent,
    MajorProjectComponent,
    MinorProjectComponent,
    StudentProjectComponent,
    PublicationComponent,
    SeminarComponent,
    WorkshopComponent,
    GuestComponent,
    FdpComponent,
    ScholarshipComponent,
    CollaborativeComponent,
    ResultComponent,
    PoCoComponent,
    WTwooneTwotwoComponent,
    WTwotwoTwothreeComponent,
    SpTwooneTwotwoComponent,
    SpTwotwoTwothreeComponent,
    MouComponent,
    ScTwooneTwotwoComponent,
    ScTwotwoTwothreeComponent,
    WTwothreeTwofourComponent,
    SpTwothreeTwofourComponent,
    ScTwothreeTwofourComponent,
    FcTwothreeTwofourComponent,
    FcTwotwoTwothreeComponent,
    FcTwofourTwofiveComponent,
    FcTwofiveTwosixComponent,
    ResearchDevelopmentCellComponent,
    ResearchEntrepreneurshipCellComponent,
    OnenineTwozeroComponent,
    TwothreeTwofourComponent,



  ],
  imports: [
    CommonModule,
    RouterModule,
    ResearchRoutingModule,
    NotFoundModule,
    PdfViewerModule,
    LoaderModule,
    SharedModule
  ]
})
export class ResearchModule { }
